import { Box, Skeleton } from '@mui/material'
import Card from '@mui/material/Card'
import CardActionArea from '@mui/material/CardActionArea'
import CardContent from '@mui/material/CardContent'
import CardMedia from '@mui/material/CardMedia'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import useFetchAccesosDirectos from 'common/hooks/useFetchAccesosDirectos'
import SSOButton from 'features/singlesignon/components/SSOButton'
import { useEffect, useState } from 'react'

import IconsList from 'common/constants/icons_map'

const AccesosDirectos = ({
  codigo = null,
  sx = null,
  clean = false,
  sxCard = {},
  sxCardMedia = {},
  sxInnerBox = {},
}) => {
  const [accesos, setAccesos] = useState([])

  const { response, loading } = useFetchAccesosDirectos(codigo)
  useEffect(() => {
    if (!loading && response) {
      setAccesos([...response])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  return (
    <Box className="accesos-directos-root" sx={sx}>
      <Box
        className="accesos-directos-flex-box"
        sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', ...sxInnerBox }}
      >
        {loading
          ? Array(4)
              .fill()
              .map((_, i) => (
                <Box key={i} size={{ xs: 6, md: 3 }}>
                  <Skeleton variant="rectangular" width={200} height={20} />
                </Box>
              ))
          : accesos.map((a, i) => {
              const Icon = a.icono ? IconsList[a.icono] : null
              return (
                <Box key={i} size={{ xs: 6, md: 3 }}>
                  {a.codigo_sso ? (
                    <SSOButton
                      sso={a.codigo_sso}
                      texto={a.titulo}
                      target={a.nueva_ventana === 'S' ? '_blank' : '_self'}
                      startIcon={Icon ? <Icon /> : null}
                    />
                  ) : (
                    <Card sx={{ minWidth: 300, maxWidth: 400, ...sxCard }}>
                      <CardActionArea
                        onClick={() =>
                          window.open(a.url, a.nueva_ventana === 'S' ? '_blank' : '_self')
                        }
                      >
                        {a.nombre_imagen ? (
                          <CardMedia
                            sx={{ height: 140, ...sxCardMedia }}
                            image={`/assets/images/enlaces/${a.nombre_imagen}`}
                            title={a.titulo}
                          />
                        ) : (
                          <></>
                        )}
                        {(a.titulo || a.descripcion) && (
                          <CardContent>
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'start',
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              {Icon ? <Icon /> : null}
                              <Typography variant="h5" component="div">
                                {a.titulo}
                              </Typography>
                            </Box>
                            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                              {a.descripcion}
                            </Typography>
                          </CardContent>
                        )}
                      </CardActionArea>
                    </Card>
                    // <Button
                    //   variant="text"
                    //   component={Link}
                    //   to={a.url}
                    //   color="primary"
                    //   size="large"
                    //   sx={{ width: '100%', px: 2, py: 1 }}
                    //   target={a.nueva_ventana === 'S' ? '_blank' : '_self'}
                    //   startIcon={Icon ? <Icon /> : null}
                    // >
                    //   {a.titulo}
                    // </Button>
                  )}
                </Box>
              )
            })}
      </Box>
      <Grid container spacing={clean ? 1 : 0}></Grid>
    </Box>
  )
}

export default AccesosDirectos
